module.exports = __webpack_public_path__ + "img/i_know.c1329aed.png";